import { Grid } from '@material-ui/core';

// locals
import { useInputChangeHandler } from 'app/hooks';
import { Constants } from 'app/utils';
import { FormInput, CustomDatePicker, FormBasicSelect } from '../../atoms';

const FilterCampaigns = ({ handleChange }) => {
  const { values, handleDebouncedValue, handleFilterInputChange } =
    useInputChangeHandler(handleChange);

  return (
    <>
      <Grid container spacing={3} className="items-center mt-8">
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <CustomDatePicker
            id="campaign_start_date"
            name="start_date"
            label="Başlangıç Tarihi"
            placeholder="Başlangıç tarihi"
            value={values?.start_date || ''}
            maxDate={values?.end_date || new Date('2100-01-01')}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <CustomDatePicker
            id="campaign_end_date"
            name="end_date"
            label="Bitiş Tarihi"
            placeholder="Bitiş tarihi"
            value={values?.end_date || ''}
            minDate={values?.start_date || new Date('1900-01-01')}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormInput
            id="campaign_user_name"
            name="name"
            label="Kampanya Adı"
            placeholder="Kampanya adı"
            onChange={handleDebouncedValue}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormBasicSelect
            initialOptText="Tümü"
            id="campaign_status"
            name="status"
            label="Durum"
            value={values?.status}
            options={Constants.activeStatuses || []}
            onChange={handleFilterInputChange}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FilterCampaigns;
